import React, {useCallback} from 'react'
import {message} from 'antd'

import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import AddressEditor from 'modules/UserProfile/Settings/AddressEditor'
import DeliveryAddress from 'modules/UserProfile/Settings/DeliveryAddress'
import AddNew from 'modules/UserProfile/Settings/AddNew'

const DeliveryAddressBlock = ({t, deliveryAddresses, reload, fixed}) => {
  const newDeliveryAddress = useCallback((values, setLoading) => {
    requestHandler(() => usersService.postDeliveryAddress(values), 'json')
      .then(r => {
        setLoading(false)
        if (r?.success) message.success(t('Saved ok'))
        reload(r => r + 1)
      })
  }, [reload, t])

  const editDeliveryAddress = useCallback((values, setLoading) => {
    requestHandler(() => usersService.patchDeliveryAddress(values.uuid, values), 'json')
      .then(r => {
        setLoading(false)
        if (r?.success) message.success(t('Saved ok'))
        reload(r => r + 1)
      })
  }, [reload, t])

  const deleteDeliveryAddress = useCallback((uuid) => {
    requestHandler(() => usersService.deleteDeliveryAddress(uuid))
      .then(r => {
        if (r?.ok) message.success(t('Deleted ok'))
        reload(r => r + 1)
      })
  }, [reload, t])

  return (
    <div className='formDesigned-block'>
      <h6>{t('Delivery addresses')}</h6>

      {deliveryAddresses ? <>
        <div className='addressEditorsBox'>
          {deliveryAddresses.map(e => (
            <AddressEditor
              key={e.uuid}
              t={t}
              data={e}
              fixed={fixed}
            >
              <DeliveryAddress
                t={t}
                data={e}
                submitCallback={editDeliveryAddress}
                deleteCallback={deleteDeliveryAddress}
                submitTitle={t('save changes')}
              />
            </AddressEditor>
          ))}
        </div>

        <AddNew title={t('Add new address')}>
          <h6>{t('Add new address')}</h6>
          <DeliveryAddress t={t} submitCallback={newDeliveryAddress} submitTitle={t('Add new address')}/>
        </AddNew>
      </> : deliveryAddresses === undefined ? (
        'loading...'
      ) : (
        'error'
      )}
    </div>
  )
}

export default DeliveryAddressBlock
